import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { chectAlreadyUser, isLoginCheck, LinkAnchor, NewYorkPopUp, refferalRouting } from "@Components/Common/CommonMethods";
import { RegionDropdown } from "react-country-region-selector";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { KitCheckoutStyle } from './KitStyle.style';
import NumberFormatComp from '@Components/Common/NumberFormatComp';
import WithoutLoginCard from '@PagesComponent/Checkout/CheckoutLogin/WithoutLoginCard';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import api from '@api/Apis';
import WithoutLoginConditon from '@PagesComponent/Checkout/CheckoutLogin/WithoutLoginConditon';
import { InputLabel } from '@material-ui/core';
import CardType from 'credit-card-type';
import { FaTrash } from 'react-icons/fa';
import { FaShoppingCart } from "react-icons/fa";
import GoogleAutocomplete from '@Components/Common/GoogleAutocomplete';
import { useRouter } from 'next/router';
// Eye visibility check
function VisibilityIconsCheck(condition, section, callback) {
    return condition ? (
        <Visibility onClick={() => callback((prv) => ({ ...prv, [section]: false }))} />
    ) : (
        <VisibilityOff onClick={() => callback((prv) => ({ ...prv, [section]: true }))} />
    );
}

//dynmic validation schema for address
const validation = (hideCardField, cardChecked) => {
    const ARRAY_VALUE = ['billing', 'shipping'];

    let LoginSchema = {
        email: yup.string().trim().required('E-mail is required').email('Please enter vaild email'),
        password: yup.string().trim().required('Password is required').min(6, "Please enter minimum 6 characters"),
        confirm_password: yup.string().trim().required('Confirm password is required')
            .test('confirm_password', 'password and confirm password should be same', function (val) {
                const password = this.resolve(yup.ref('password'));
                if (val !== password) return false;
                return true;
            }),
    };

    let cardSchema = {
        cardCVC: yup.string().required('Enter CVV').matches(/^[0-9]{3,4}$/, "Enter valid CVV"),
        cardHolder: yup.string().required('This field is required'),
        cardNumber: yup.string()
            .required('Please enter your card number')
            .matches(
                /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/,
                "Please Enter Valid card Number"),
        card_expiry_month: yup.string().required('Enter your expiry month'),
        card_expiry_year: yup.string().required('Enter your expiry year'),
    };

    let schemmaValue = {
        termscondition3: yup.boolean().oneOf([true], 'Please read and accept the conditions')
    };

    if (!isLoginCheck()) {
        schemmaValue = { ...schemmaValue, ...LoginSchema, ...cardSchema };
    } else {
        schemmaValue = (hideCardField && !cardChecked) ? { ...schemmaValue, ...cardSchema } : schemmaValue;
    }

    _.forEach(ARRAY_VALUE, (section) => _.assign(schemmaValue, {
        [`${section}_first_name`]: yup.string().trim().required('First name is required').min(2, "Enter minimum 2 character"),
        [`${section}_last_name`]: yup.string().trim().required('Last name is required').min(2, "Enter minimum 2 character"),
        [`${section}_postal_code`]: yup.string().required('Zip code is required'),
        // [`${section}_street_address_1`]: yup.string().required('Address field is required'),
        [`${section}_city`]: yup.string().required('City field is required'),
        [`${section}_country`]: yup.string().required('Please select country'),

        [`_phone_number`]: !isLoginCheck() ? yup.string().typeError('Please enter only number')
            .required('Phone number is required') : yup.string().notRequired()


        // [`${section}_country`]: yup.string().required('this field is required'),
    }))
    return schemmaValue;
}

//Discount Check

const DiscountKitSection = (props) => {
    // setpaidamount(reviewshow?.amount + (taxPrice !== undefined ? taxPrice : 0) + parseFloat(shippingChargesAmount !== null ? shippingChargesAmount : 0) - discountValue);

    return (
        <div className="cupon_and_kiare_section">
            <div className="coupam-enter">
                {((props?.discountValues?.amount) && props?.discountValues?.couponCode)
                    ?
                    <h4 className="title">{props?.discountValues?.couponCode} Coupon Added <FaTrash onClick={(e) => props?.removedCoupon(e)} /></h4>
                    :
                    <div className="apply-coupn">
                        <label htmlFor="coupn"> <b> COUPON CODE </b></label>
                        <div className="wrap-form">
                            <input
                                type="text" className="form-control"
                                name="coupon_id" placeholder="coupon"
                                value={props?.discountValues?.couponCode}
                                onChange={(e) => props?.setDiscountValue((prv) => ({ ...prv, couponCode: e.target.value, amount: null }))}
                            />
                            <button type="button" className="btn btn-primary" onClick={() => props?.appliedCouponFunc(props?.totalPrice)}>Apply</button>
                        </div>
                        {props?.discountValues?.error && <span className='copanerror-cls'>{props?.discountValues?.error}</span>}
                    </div>
                }
            </div>
        </div>
    );
}

// Dynamic input function
function _inputFields(name, placeholder, methods, classes = "", label = "", eyeIcon = false, visibility = false, callback) {

    return (
        <div className={`field-class ${classes}`}>
            {label && <label htmlFor="inputvalue" className="form-label">{label}</label>}
            <div className='input_and_eye'>
                {eyeIcon
                    ?
                    <>
                        <input type={!visibility ? "password" : "text"} className="form-control" name={name} placeholder={placeholder} ref={methods?.register} />
                        {eyeIcon && VisibilityIconsCheck(visibility, name, callback)}
                    </>
                    :
                    <input type="text" className="form-control" name={name} placeholder={placeholder} ref={methods?.register} onBlur={(e) => callback ? callback(e.target.value) : ''} />
                }
            </div>
            {methods?.errors?.[name] && (<span className="error">{methods?.errors?.[name]?.message}</span>)}
        </div>
    )
}

const EmailPasswordHtml = ({ methods, setHide, hide }) => {
    const [passwordShow, setPasswordShow] = useState({
        password: false,
        confirm_password: false
    });

    function _onInputBlur(email) {
        chectAlreadyUser(email).then((res) => setHide(res)).catch((err) => err);
    }
    return (
        <>
            {/* <h4 className="title">Register</h4> */}
            <div className='main-left'>
                <div className={`field-class`}>
                    <label htmlFor="exampleInputEmail1" className="form-label">Contact</label>
                    <input type="text" className="form-control" name="email" placeholder="Email Address"
                        ref={methods.register} onBlur={(e) => _onInputBlur(e.target.value)} />
                    {methods?.errors?.email && (<span className="error"> {methods?.errors?.email?.message} </span>)}
                </div>
                {!hide
                    ?
                    <>
                        {_inputFields("password", 'Password', methods, '', 'Password', true, passwordShow['password'], setPasswordShow)}
                        {_inputFields("confirm_password", 'Confirm Password', methods, '', 'Confirm Password', true, passwordShow['confirm_password'], setPasswordShow)}
                    </>
                    :
                    <div className="already_exist_customer"><span>You are already registered with this email please</span>&nbsp;
                        <LinkAnchor href={refferalRouting("/us/login/?redirectTo=consentForm-checkout   ")}
                        > Login</LinkAnchor>
                    </div>
                }
            </div>
        </>
    )
}


// without login addressFields

const AddressFields = forwardRef(({ children, section, methods, shippingStateError, setBillingStateError, setShippingStateError, billingStateError, stateFieldData, state, setState, setStateFieldData,
    streetData, setStreetData, dataError, setDataError, profileData }, ref) => {
    const [newYorkCheck, setNewyorkCheck] = useState(false);
    useEffect(() => {
        setStreetData(prevStreetData => ({
            ...prevStreetData,
            [`${section}Street`]: profileData?.user_data?.user_addresses?.[0]?.street_address_1
        }));

        setState(preStateData => ({ ...preStateData, [`${section}_state`]: profileData?.user_data?.user_addresses?.[0]?.state }));
        methods.setValue(`${section}_state`, profileData?.user_data?.user_addresses?.[0]?.state);
        methods.setValue(`${section}_country`, profileData?.user_data?.user_addresses?.[0]?.country);
        methods.setValue(`${section}_street_address_1`, profileData?.user_data?.user_addresses?.[0]?.street_address_1);
        methods.setValue(`${section}_city`, profileData?.user_data?.user_addresses?.[0]?.city);
        methods.setValue(`${section}_postal_code`, profileData?.user_data?.user_addresses?.[0]?.postal_code);
        methods.setValue(`${section}_first_name`, profileData?.user_data?.user_addresses?.[0]?.first_name);
        methods.setValue(`${section}_last_name`, profileData?.user_data?.user_addresses?.[0]?.last_name);

    }, [profileData])

    // const GETDATA = localStorage.getItem('freeKitProps?.profileData') ? JSON.parse(localStorage.getItem('freeKitProps?.profileData'))?.user_data?.userdetails[0] : ""

    function setCityPostLineOne(sec, field, val) {
        setStateFieldData((prevState) => ({
            ...prevState,
            [`${sec}_${field}`]: val,
        }));
    }

    function _googleAddressSetup(results, callback = null) {
        if (results) {
            let ADDRESS = {};
            for (const component of results.address_components) {
                const componentType = component.types[0];
                switch (componentType) {
                    case "street_number":
                        ADDRESS['shipping_street'] = `${component.long_name}`;
                        break;
                    case "route":
                        ADDRESS['shipping_street'] = `${ADDRESS?.shipping_street || ''} ${component.long_name}`;
                        break;
                    case "postal_code":
                        ADDRESS['shipping_zipcode'] = `${component.long_name}`;
                        break;
                    case "locality":
                        ADDRESS['shipping_city'] = component.long_name;
                        break;
                    case "administrative_area_level_1":
                        ADDRESS['shipping_state'] = component.short_name;
                        break;
                    case "country":
                        ADDRESS['shipping_country'] = component.short_name;
                        break;
                }
            }
            if (callback) {
                callback(ADDRESS)
            }

        }
    };
    function _handelGooglePlace(results, data) {
        if (results) {
            _googleAddressSetup(results, (ADDRESS) => {

                setStreetData(prevState => ({
                    ...prevState,
                    [`${section}Street`]: ADDRESS?.shipping_street || "",
                }));

                setStateFieldData(prevState => ({
                    ...prevState,
                    [`${section}_country`]: ADDRESS?.shipping_country || "",
                    [`${section}_street_address_1`]: ADDRESS?.shipping_street || "",
                    [`${section}_city`]: ADDRESS?.shipping_city || "",
                    [`${section}_postal_code`]: ADDRESS?.shipping_zipcode || "",
                    [`${section}_state`]: ADDRESS?.shipping_state || "",
                }));

                methods.setValue(`${section}_country`, ADDRESS?.shipping_country || "");
                methods.setValue(`${section}_street_address_1`, ADDRESS?.shipping_street || "");
                methods.setValue(`${section}_city`, ADDRESS?.shipping_city || "");
                methods.setValue(`${section}_postal_code`, ADDRESS?.shipping_zipcode || "");
                methods.setValue(`${section}_state`, ADDRESS?.shipping_state || "");

                methods.trigger(`${section}_country`);
                methods.trigger(`${section}_street_address_1`);
                methods.trigger(`${section}_city`);
                methods.trigger(`${section}_postal_code`);
                methods.trigger(`${section}_state`);

                setState(prevState => ({
                    ...prevState,
                    [`${section}_state`]: ADDRESS?.shipping_state || "",
                }));

                if (state?.billing_state !== "" && section === 'billing') {
                    setBillingStateError('');
                }
                if (state?.shipping_state !== "" && section === 'shipping') {
                    setShippingStateError('');
                }
            });
        }
    }


    return (
        <div className="signupform main-sign-frm" ref={ref}>
            {/* <h4 className="title">{section === "billing" ? `${section} Address` : 'Delivery'}</h4> */}
            <div className="same_as_shipping">{children}</div>
            <h2 >{section !== "billing" && 'Delivery'}</h2>
            <h2 >{section === "billing" && 'Billing'}</h2>

            <div className="main-wrapper d-flex">
                <div className="field-class">
                    <div className="select">
                        <select name={`${section}_country`} ref={methods?.register}>
                            <option value="US">United States</option>
                            <option value="CA">Canada</option>
                            <option value="GB">UK</option>
                            <option value="AU">Australia</option>
                            <option value="DE">Germany</option>
                            <option value="DK">Denmark</option>
                            <option value="FI">Finland</option>
                            <option value="NL">Netherlands</option>
                            <option value="SE">Sweden</option>
                            <option value="IE">Ireland</option>
                        </select>
                    </div>
                    {methods?.errors?.[`${section}_country`] && (
                        <span className="error">
                            {methods?.errors?.[`${section}_country`]?.message}
                        </span>
                    )}
                </div>
                {/* <div className="field-class"> */}

                {/* </div> */}
                {_inputFields(`${section}_first_name`, "First Name", methods)}
                {_inputFields(`${section}_last_name`, "Last Name", methods)}
                {/* {_inputFields(`${section}_company_name`, "Company Name", methods, 'company-line')} */}
                {/* {_inputFields(`${section}_street_address_1`, "Address 1", methods, "", "", false, false, (val) => setCityPostLineOne("line1", val))} */}
                <div className="field-class company-line">
                    <GoogleAutocomplete
                        name={`${section}_street_address_1`}
                        defaultValue={streetData?.[`${section}Street`] || ""}
                        onChange={(val) => {
                            methods.setValue(`${section}_street_address_1`, val);
                            // freeKitProps?.setStreetData({ ...val, [`${section}Street`]: val });
                            setStreetData(prevStreetData => ({
                                ...prevStreetData,
                                [`${section}Street`]: val
                            }));

                            if (val === "") {
                                setDataError({ ...dataError, [`${section}ErrorMsg`]: `please enter the ${section} street address` });
                            } else {
                                setDataError({ ...dataError, [`${section}ErrorMsg`]: "" });
                            }

                        }}

                        manually={false}
                        InputClassName="pl-3.5"
                        LabelClassName="!pl-0"
                        callback={(data) => _handelGooglePlace(data)}
                        streetData={streetData}
                    />

                    {dataError?.[`${section}ErrorMsg`] &&
                        <span className="error">{dataError?.[`${section}ErrorMsg`]}</span>
                    }
                </div>
                <div className="field-class company-line">
                    {_inputFields(`${section}_street_address_2`, "Address 2", methods)}
                </div>
                <div className="data-city-zip">

                    {_inputFields(`${section}_city`, "City", methods, "", "", false, false,
                        (val) => setCityPostLineOne(section, "city", val)
                    )}

                    <div className="field-class ">
                        <RegionDropdown country={methods?.getValues(`${section}_country`)} value={state[`${section}_state`]} name={`${section}_state`}
                            valueType="short" defaultOptionLabel="State" countryValueType="short" onChange={(val) => {
                                if (val === "NY") { setNewyorkCheck(true) } else { setNewyorkCheck(false) };
                                setState({ ...state, [`${section}_state`]: val });
                                if (val === "") {
                                    if (section !== "billing") {
                                        setShippingStateError('Please select state');
                                    } else {
                                        setBillingStateError('Please select state');
                                    }
                                } else {
                                    if (section !== "billing") {
                                        setShippingStateError('');
                                    } else {
                                        setBillingStateError('');
                                    }
                                }
                                // setState({ ...state, shipping_state: val, billing_state: val });
                            }}
                        />
                        {section === "shipping" ? shippingStateError && <span className="error">{shippingStateError}</span> : billingStateError && <span className="error">{billingStateError}</span>}
                    </div>

                    <NewYorkPopUp open={newYorkCheck} setClose={setNewyorkCheck} />


                    {_inputFields(`${section}_postal_code`, "Zip Code", methods, "", "", false, false,
                        (val) => setCityPostLineOne(section, "postalCode", val)
                    )}

                    {/* {_inputFields(`${section}_phone_number`, "Phone", methods, "company-line")} */}
                </div>
            </div>
        </div >
    )
})

// kit checkout main component
const KitCheckout = ({ freeKitProps }) => {

    const [selectedProductFreq, setSelectedProductFreq] = useState({
        product_id: null, shipping_amount: null, quantity: null,
        shipping_module_id: null, variant_id: null, shipping_frequency: null,
        is_autoship: true, tax_amount: null, amount: null,
    });

    const [hideCardField, setHideCardField] = useState(false);
    const [cardChecked, setCardChecked] = useState({
        currentValue: _.find(freeKitProps?.savedCard?.saved_cards, { default_card: true })?.id || null,
        duplicateValue: _.find(freeKitProps?.savedCard?.saved_cards, { default_card: true })?.id || null
    })

    const scrollRef = useRef(null);
    const router = useRouter();
    const [state, setState] = useState({ shipping_state: "", billing_state: "" });
    const [allPrice, setAllPrice] = useState({ total: null, taxPrice: null });
    const [stateFieldData, setStateFieldData] = useState({ "city": null, "line1": null, "postalCode": null });
    const [taxError, SetTaxError] = useState('');
    const [hide, setHide] = useState(false);
    const [autoshipShippingError, setAutoShipShippingError] = useState('');

    const schema = yup.object().shape(validation(hideCardField, cardChecked))
    const methods = useForm({
        mode: "all", defaultValues: {
            termscondition: true,
            termscondition1: true,
            termscondition2: true
        }, resolver: yupResolver(schema)
    });



    useEffect(() => {
        api.searchbarcode(localStorage.getItem("Token"), { barcode: localStorage.getItem("barcode") }).then((res) => {
            if (res?.data?.code === 1) {
                if (isLoginCheck()) {
                    if (res?.data?.products_data?.length > 0) {
                        freeKitProps?.setFreeKitProduct(res?.data?.products_data);
                        freeKitProps?.setDuplicateFreeKitProduct(res?.data?.products_data);
                        const postalCode = methods.getValues('billing_postal_code') || stateFieldData?.shipping_postal_code || "";
                        const PRODUCT_DATA_ARRAY = _.map(res?.data?.products_data, (row, index) => {
                            setAllPrice((prv) => ({ ...prv, total: +row?.cost_price }));
                            return ({ amount: parseFloat(row?.cost_price), sku: row?.sku, quantity: 1, number: index + 1, taxcode: row?.tax_code })
                        });

                        // if (state?.shipping_state !== null && stateFieldData?.city && stateFieldData?.line1 && stateFieldData?.postalCode) {
                        if (res?.data?.products_data?.length > 0) {
                            api.calculateTaxAmount({
                                "city": methods.getValues('billing_city') || stateFieldData?.shipping_city,
                                "country": methods.getValues('billing_country') || stateFieldData?.shipping_country,
                                "line1": freeKitProps?.streetData?.shippingStreet || stateFieldData?.shipping_street,
                                "postalCode": postalCode,
                                // "region": state?.shipping_state,
                                "region": state?.billing_state ? state?.billing_state : stateFieldData?.shipping_state,
                                "products": PRODUCT_DATA_ARRAY
                            }).then((res) => {
                                if (res.status === 200) {
                                    if (res?.data?.code === 1) {
                                        setAllPrice((prv) => ({ taxPrice: res?.data?.totalTax, total: +prv?.total + res?.data?.totalTax }));
                                    } else {
                                        SetTaxError(res?.data?.message);
                                        setAllPrice((prv) => ({ taxPrice: '', total: +prv?.total }));
                                        setTimeout(() => SetTaxError(''), 6000);
                                    }

                                }
                            }).catch((err) => {
                                throw new Error('error comming from RelatedProducts', err)
                            })
                        }
                    }
                }
            }
        })
    }, [router, stateFieldData, state?.shipping_state])


    function SameAsShipping(e, row) {
        if (e.target.checked) {
            freeKitProps?.setStreetData({ ...freeKitProps?.streetData, billingStreet: freeKitProps?.streetData?.shippingStreet });
            setDataError({ ...dataError, [`${row}ErrorMsg`]: "" });
            methods?.setValue("billing_first_name", methods?.getValues(`shipping_first_name`), { shouldValidate: true });
            methods?.setValue("billing_last_name", methods?.getValues(`shipping_last_name`), { shouldValidate: true });
            methods?.setValue("billing_company_name", methods?.getValues(`shipping_company_name`), { shouldValidate: true });
            methods?.setValue("billing_city", methods?.getValues(`shipping_city`), { shouldValidate: true });
            methods?.setValue("billing_street_address_1", methods?.getValues(`shipping_street_address_1`), { shouldValidate: true });
            methods?.setValue("billing_street_address_2", methods?.getValues(`shipping_street_address_2`), { shouldValidate: true });
            methods?.setValue("billing_postal_code", methods?.getValues(`shipping_postal_code`), { shouldValidate: true });
            methods?.setValue("billing_phone_number", methods?.getValues(`shipping_phone_number`) ? methods?.getValues(`shipping_phone_number`) : "");
            methods?.setValue("billing_country", methods?.getValues(`shipping_country`), { shouldValidate: true });
            // setBillingCountry(shippingCountry);
            // setBillingState(shippingState);
            setState({ ...state, billing_state: state?.shipping_state });

            if (state?.shipping_state !== undefined && state?.shipping_state !== "") {
                setBillingStateError('');
            } else {
                setBillingStateError('Please select state');
            }
        }

    };

    async function _texCalculationApi() {
        const postalCode = methods.getValues('billing_postal_code') || stateFieldData?.shipping_postal_code || "";
        const PRODUCT_DATA_ARRAY = _.map(freeKitProps?.freeKitProduct, (row, index) => {
            setAllPrice((prv) => ({ ...prv, total: +row?.cost_price }));
            return ({ amount: parseFloat(row?.cost_price), sku: row?.sku, quantity: 1, number: index + 1, taxcode: row?.tax_code })
        });

        // if (state?.shipping_state !== null && stateFieldData?.city && stateFieldData?.line1 && stateFieldData?.postalCode) {
        if (freeKitProps?.freeKitProduct?.length > 0) {
            await api.calculateTaxAmount({
                "city": methods.getValues('billing_city') || stateFieldData?.shipping_city,
                "country": methods.getValues('billing_country') || stateFieldData?.shipping_country,
                "line1": freeKitProps?.streetData?.shippingStreet || stateFieldData?.shipping_street,
                "postalCode": postalCode,
                // "region": state?.shipping_state,
                "region": state?.billing_state ? state?.billing_state : stateFieldData?.shipping_state,
                "products": PRODUCT_DATA_ARRAY
            }).then((res) => {
                if (res.status === 200) {
                    if (res?.data?.code === 1) {
                        setAllPrice((prv) => ({ taxPrice: res?.data?.totalTax, total: +prv?.total + res?.data?.totalTax }));
                    } else {
                        SetTaxError(res?.data?.message);
                        setAllPrice((prv) => ({ taxPrice: '', total: +prv?.total }));
                        setTimeout(() => SetTaxError(''), 6000);
                    }

                }
            }).catch((err) => {
                throw new Error('error comming from RelatedProducts', err)
            })
        }

        // }
    }



    useEffect(() => { _texCalculationApi(); }, [stateFieldData, state?.shipping_state])


    const [billingStateError, setBillingStateError] = useState("");
    const [shippingStateError, setShippingStateError] = useState("");
    // const [freeKitProps?.streetData, freeKitProps?.setStreetData] = useState({
    //     "billingStreet": "",
    //     "shippingStreet": ""
    // });
    const [dataError, setDataError] = useState({
        "billingErrorMsg": "",
        "shippingErrorMsg": "",
        // "billingStateErrorMsg":"",
        // "shippingStateErrorMsg":""
    });
    function _onSubmit(data) {
        freeKitProps?.setInnerLoader(true);
        // if (selectedProductFreq?.product_id && selectedProductFreq?.shipping_amount === null) {
        //     setAutoShipShippingError("Please select shipping method.")
        //     return null;
        // }
        let PRODUCT = _.map(freeKitProps?.freeKitProduct, (row) => ({
            product_id: parseInt(+row?.id),
            quantity: parseInt(1),
            sku: row?.sku,
            variant_id: null,
            is_autoship: false
        }));
        // data = data._phone_number ? data._phone_number : ""
        data = _.assign(data, { ...state, ...allPrice });
        data['selectedProductFreq'] = selectedProductFreq;
        data['products'] = PRODUCT;
        data['payment_details'] = {
            card_expiry_month: data?.card_expiry_month,
            card_expiry_year: data?.card_expiry_year,
            card_number: data?.cardNumber,
            card_owner_name: data?.cardHolder,
            card_type: CardType(data["cardNumber"]).length > 0 ? CardType(data["cardNumber"])[0]?.type : 'visa',
            security_code: data?.cardCVC
        }
        data['saved_card_id'] = cardChecked?.currentValue ? cardChecked?.currentValue : null;

        if (!isLoginCheck()) {
            data["new_user"] = { parentrefferalPromoter: null, new_email: data['email'], new_password: data['password'] };
            const data_sign = { email: data.email, password: data.password };
            localStorage.setItem("logincredentials", JSON.stringify(data["new_user"]))
        }

        if (state?.billing_state === "" && state?.shipping_state === "") {
            setBillingStateError('Please select state');
            setShippingStateError('Please select state');
            freeKitProps?.setInnerLoader(false);
            scrollRef.current.scrollIntoView();
            return;
        } else if (state?.billing_state === "" || state?.billing_state === undefined) {

            setBillingStateError('Please select state');
            setShippingStateError('');
            scrollRef.current.scrollIntoView();
            freeKitProps?.setInnerLoader(false);
            return;
        } else if (state?.shipping_state === "" || state?.shipping_state === undefined) {

            setShippingStateError('Please select state');
            setBillingStateError('');
            scrollRef.current.scrollIntoView();
            freeKitProps?.setInnerLoader(false);
            return;
        } else {
            setBillingStateError("");
            setShippingStateError('');
        }
        // if(shippingStateError === "" && billingStateError===""){
        freeKitProps?.handleCheckoutSubmit(data);
        // }
    }
    function handleClickAddress() {

        if (freeKitProps?.streetData?.billingStreet === "" || freeKitProps?.streetData?.billingStreet === undefined) {
            // setDataError({ ...dataError, [`${'billing'}ErrorMsg`]: `please enter the ${'billing'} street address` });
            setDataError(dataError => ({
                ...dataError,
                [`${'billing'}ErrorMsg`]: `please enter the ${'billing'} street address`,
                // [`${'billingState'}ErrorMsg`]: "",

            }));

            setBillingStateError('Please select state');

        }
        if (freeKitProps?.streetData?.shippingStreet === "" || freeKitProps?.streetData?.shippingStreet === undefined) {
            // setDataError({ ...dataError, [`${'shipping'}ErrorMsg`]: `please enter the ${'shipping'} street address` });
            setDataError(dataError => ({
                ...dataError,
                [`${'shipping'}ErrorMsg`]: `please enter the ${'shipping'} street address`,
                // [`${'billingState'}ErrorMsg`]: "",

            }));
            setShippingStateError('Please select state');

        }
    }
    const selectedDataId = cardChecked.currentValue;
    const handleRadioChange = (cardId) => {
        setCardChecked({
            currentValue: cardId,
            duplicateValue: cardId
        });
        // setHideCardField(!hideCardField);
    }

    return (
        <KitCheckoutStyle>
            {/* <button onClick={() => freeKitProps?.setBarCodeValue(null)}>Back</button> */}
            {isLoginCheck &&
                <header className="checkout-header-wrap">
                    <div className="container">
                        <div className="checkout-header-row">
                            <a href="/" className="checkout-header-logo">
                                SNiP Nutrigenomics
                            </a>
                            {/* <a href="/us/cart/viewCart/" className="checkout-cart">
                                <FaShoppingCart />
                            </a> */}
                        </div>
                    </div>
                </header>
            }
            <FormProvider {...methods}>
                <div className="main_sign_up_form_class">
                    <form onSubmit={methods?.handleSubmit(_onSubmit)}>
                        <div className='left_section'>
                            <div className="left_section-wrap">
                                {!(isLoginCheck()) &&
                                    <>
                                        <div className='login_check_section'>
                                            <EmailPasswordHtml {...{ methods, setHide, hide }} />
                                        </div>
                                        <div className=''>
                                            {_inputFields(`_phone_number`, "Phone", methods, "company-line")}
                                        </div>
                                    </>
                                }
                                {!hide &&
                                    <>
                                        <div className='billing_shipping_section'>
                                            {_.map(['shipping', 'billing'], (row, index) => (
                                                <AddressFields ref={scrollRef} key={row?.toString()} setBillingStateError={setBillingStateError} shippingStateError={shippingStateError} setShippingStateError={setShippingStateError}
                                                    section={row} methods={methods} state={state} billingStateError={billingStateError} setState={setState} setStateFieldData={setStateFieldData}
                                                    streetData={freeKitProps?.streetData} setStreetData={freeKitProps?.setStreetData}
                                                    dataError={dataError} setDataError={setDataError} profileData={freeKitProps?.profileData} stateFieldData={stateFieldData}
                                                >
                                                    {index === 1 && <div><input type="checkbox" onChange={(e) => SameAsShipping(e, row)} />Same as delivery address</div>}
                                                </AddressFields>
                                            ))}
                                        </div>
                                        {taxError && <span className='error'>{taxError}</span>}


                                        <div className='orderDetail_section'>

                                            {(isLoginCheck()) &&
                                                <>
                                                    <div className='forLogin_card_section'>
                                                        <InputLabel htmlFor="filled-age-native-simple" className="choose_label" required>
                                                            Choose a Payment method:
                                                        </InputLabel>
                                                        <div className='saved_card_login'>
                                                            {freeKitProps?.savedCard?.saved_cards?.map((cards) => {
                                                                return (
                                                                    <div className='saved-main-card d-flex' key={cards?.id}>
                                                                        <input
                                                                            type="radio"
                                                                            checked={cards?.id === selectedDataId}
                                                                            value={cards?.id}
                                                                            onChange={() => handleRadioChange(cards?.id)}
                                                                        />
                                                                        <div className='card-name'>{cards?.card_type}</div>
                                                                        <div className='card-number'>{cards?.card_number}</div>
                                                                    </div>
                                                                )
                                                            })}
                                                        </div>
                                                        <button type="button" onClick={() => {
                                                            setHideCardField(!hideCardField);
                                                            if (!hideCardField) {
                                                                setCardChecked((prv) => ({ ...prv, currentValue: null }));
                                                            } else {
                                                                setCardChecked((prv) => ({ ...prv, currentValue: prv?.duplicateValue }));
                                                            }
                                                        }}>Add New</button>
                                                    </div>
                                                    {hideCardField && <WithoutLoginCard isAutoship={false} />}
                                                </>
                                            }
                                            {!(isLoginCheck()) && <WithoutLoginCard isAutoship={false} />}
                                        </div>
                                        <WithoutLoginConditon />
                                        <div className='order_button'> <button type='submit' onClick={handleClickAddress}>Order Now</button> </div>
                                        {freeKitProps?.errorCheck && <span className='error'>{freeKitProps?.errorCheck}</span>}
                                    </>
                                }
                            </div>
                        </div>
                        <div className='right_section'>
                            <div className="left_section-wrap">
                                {!hide &&
                                    <>
                                        {/* <div className='heading_section'><h2>Order Detail</h2></div> */}
                                        <div className='table-responsive'>
                                            <div className='productItems'>
                                                {/* <thead>
                                                    <tr>{_.map(['Product Image', 'Product Name', 'Quantity', 'Price'], (row, index) => <th key={String(index) + 'now'}>{row}</th>)}</tr>
                                                </thead> */}
                                                <div className='productList'>
                                                    {_.map(freeKitProps?.freeKitProduct, (row, index) => (
                                                        <div className='productInfo' key={row?.id}>
                                                            <div data-value="Product Image" className='productImage'>
                                                                <div className="">
                                                                    <img src={`${process.env.API_URL}${row?.product_images[0]?.image}`}
                                                                        height='100' width='100' />
                                                                </div>
                                                            </div>
                                                            <div className='productName' data-value="Product Name">{row?.name}</div>
                                                            {/* <td data-value="Quantity">1</td> */}
                                                            <div className='productPrice' data-value="Price">{row?.cost_price}</div>
                                                        </div>
                                                    ))}
                                                    <DiscountKitSection totalPrice={allPrice?.total} {...freeKitProps} />
                                                    <div className='border_table_row'>
                                                        {/* <div className='shipping' colSpan={2}></div> */}
                                                        <div className="amount_title" colSpan={2}>
                                                            <div className="Total">
                                                                <strong>Sub-total:</strong>
                                                                <NumberFormatComp value={freeKitProps?.freeKitProduct?.[0]?.cost_price} />
                                                            </div>
                                                            {(allPrice?.taxPrice || allPrice?.taxPrice === 0) &&
                                                                <div className="Total">
                                                                    <strong>Tax:</strong>
                                                                    <NumberFormatComp value={allPrice?.taxPrice} />
                                                                </div>
                                                            }
                                                            {(freeKitProps?.discountValues?.couponCode && freeKitProps?.discountValues?.amount) &&
                                                                <div className="Total Discount">
                                                                    <strong>Discount Amount ({freeKitProps?.discountValues?.couponCode}):</strong>
                                                                    -<NumberFormatComp value={freeKitProps?.discountValues?.amount} />
                                                                </div>
                                                            }
                                                            <div className="Total">
                                                                <strong>Total:</strong>
                                                                <NumberFormatComp value={allPrice?.total - (freeKitProps?.discountValues?.amount ? freeKitProps?.discountValues?.amount : 0)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </form>
                </div>
            </FormProvider>
            {freeKitProps?.innerLoader === true && (
                <div className="flexbox">
                    <div className="">
                        <div className="bt-spinner"></div>
                    </div>
                </div>
            )}
        </KitCheckoutStyle>
    )
}
export default KitCheckout;

